import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, SUPPORT_EMAIL } from "@/lib/content";

const SHOP_LINKS = [
  { to: "/shop", label: "SHOP ALL" },
  { to: "/collections/jojo-drop-001", label: "JOJO DROP 001" },
  { to: "/collections/evangelion-drop", label: "EVANGELION DROP 002" },
];

const SUPPORT_LINKS = [
  { to: "/about", label: "ABOUT US" },
  { to: "/contact", label: "CONTACT" },
  { to: "/shipping", label: "SHIPPING POLICY" },
  { to: "/returns", label: "RETURNS & EXCHANGES" },
  { to: "/privacy", label: "PRIVACY POLICY" },
  { to: "/terms", label: "TERMS & CONDITIONS" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 sm:pt-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-bone/55">
              Luxury-quality anime streetwear, sourced and curated in India. Not made to blend in.
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              className="mt-6 inline-flex items-center gap-2 border border-line px-5 py-3 font-mono text-[10px] uppercase tracking-[0.25em] text-bone/80 transition-colors hover:border-violet hover:text-gold"
            >
              <Instagram className="h-4 w-4" strokeWidth={1.5} />
              {INSTAGRAM_HANDLE}
            </a>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-email-link"
              className="mt-4 block font-mono text-[10px] uppercase tracking-[0.25em] text-bone/40 transition-colors hover:text-bone"
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">SHOP</p>
            <ul className="mt-5 space-y-3">
              {SHOP_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.to.replace(/\//g, "").replace(/\//g, "-") || "shop"}-link`}
                    className="group inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60 transition-colors hover:text-bone"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">SUPPORT</p>
            <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {SUPPORT_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="group inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60 transition-colors hover:text-bone"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" strokeWidth={1.5} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <p className="text-stroke-bone whitespace-nowrap font-display text-[18vw] leading-none tracking-[0.05em] opacity-25 md:text-[11rem]">
            REQUIEM FEVER
          </p>
        </div>
        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone/40">
            © {new Date().getFullYear()} REQUIEM FEVER · ALL RIGHTS RESERVED
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone/40">MADE IN INDIA</p>
        </div>
      </div>
    </footer>
  );
}
